/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-08 16:06:43
 * @LastEditors: caiqin.xie
 * @message: 作者信息
 */
import React from "react";
import styles from "../../index.module.scss";
import {CopyToClipboard} from "react-copy-to-clipboard"
import { Notification } from '@arco-design/web-react';
import LazyMedia from "@/components/LazyMedia";

const Facebook_icon = require('../../../assets/Facebook.svg');
const Twitter_icon = require('../../../assets/Twitter.svg');
const message_icon = require('../../../assets/message.svg');

interface IAuthorInfo {
  profileImageUrl: string; // 作者头像
  profileImageAlt: string; // 作者头像alt
  name: string; // 作者名称
  shortIntroduction: string; // 作者简介
  faceBook: string; // 作者facebook
  twitter: string; // 作者twitter
  email: string; // 作者邮箱
  [key:string]: any;
}

interface IProps {
  authorDetailVO: IAuthorInfo,
  ctry: string;
  words: Record<string, string>;
}

const AuthorInfo = (props:IProps) => {
  const {authorDetailVO, ctry, words} = props

  const handleCopy = () => {
    console.log('copy success')
    Notification.success({
      title: '',
      content: words?.blog_copy_email_success,
    })
    // Replicating Success
  }

  return (
    <>
    {authorDetailVO && (
      <div className={styles['blog-author-banner']}>
        <div className={styles['author-pic']}>
          <LazyMedia type="image" LazyClassName="full-wh" src={authorDetailVO?.profileImageUrl} alt={authorDetailVO?.profileImageAlt} />
        </div>
        <div className={styles['author-info-wrap']}>
          <p className={styles['author-name']} title={authorDetailVO?.name}>{authorDetailVO?.name}</p>
          <p className={styles['author-info']} title={authorDetailVO?.shortIntroduction}>{authorDetailVO?.shortIntroduction}</p>
          <p className={styles['author-line']}>
            <a href={authorDetailVO?.faceBook} target="_blank"><img src={Facebook_icon} alt={words?.common_facebook} /></a>
            <a href={authorDetailVO?.twitter} target="_blank"><img src={Twitter_icon} alt={words?.common_twitter} /></a>
            {authorDetailVO && authorDetailVO.email && (
              <CopyToClipboard
                onCopy={handleCopy}
                text={authorDetailVO.email}>
                <span className={`${styles.cp} ${styles['eamil-wrap']}`}><img src={message_icon} alt={words?.common_email} />{authorDetailVO.email}</span>
              </CopyToClipboard>
            )}
            {/* Facebook */}
            {/* Twitter */}
            {/* Email */}
          </p>
        </div>
      </div>
    )}
    </>

  )
}
export default AuthorInfo
